import React from 'react';
import PropTypes from 'prop-types';


class ImageLink extends React.Component {

  render() {
    const imgLinkData = this.props.imgLinkData || [];
    return (
      <a href={imgLinkData.href} className={imgLinkData.linkClass} title={imgLinkData.label} >
        <img src={imgLinkData.src} alt={imgLinkData.alt} id={imgLinkData.id} className={imgLinkData.imgClass} />
      </a>
    );
  }
}

ImageLink.propTypes = {
  imgLinkData: PropTypes.object.isRequired,
};

ImageLink.defaultProps = {
  imgLinkData: {},
};

export default ImageLink;
